import { Location } from '@angular/common';
import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Dialog } from 'primeng/dialog';

import { JobsService } from '@app/shared/jobs.service';
import { Job } from '@app/shared/shared.models';

@Component({
  styleUrls: ['./overview.component.css'],
  templateUrl: './overview.component.html',
})
export class OverviewComponent implements OnInit, OnDestroy {
  /// Remove this when quick-apply api is ready
  careerURL: string;
  divisionDescription: string;
  isLoading = false;
  /// Remove this when quick-apply api is ready
  isQuickApplyReady = true;
  job: Job;
  recordSource: string;
  visibleApplyNowComponent = false;
  visibleApplyNowDialog = false;

  private readonly careerDomain = window.__env.ngSettings.careerDomain;
  private city: string;
  private jobId: string;
  private navigationSubscription: any;
  private state: string;

  constructor(
    private activatedRoute: ActivatedRoute,
    private jobsService: JobsService,
    private location: Location,
    private renderer: Renderer2,
    private router: Router
  ) {
    this.navigationSubscription = this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.jobId = this.activatedRoute.snapshot.paramMap.get('id');
        this.state = this.activatedRoute.snapshot.paramMap.get('state');
        this.city = this.activatedRoute.snapshot.paramMap.get('city');
        this.recordSource = this.activatedRoute.snapshot.paramMap.get('recordSource');
        this.setData();
      }
    });
  }

  back() {
    this.location.back();
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.divisionDescription =
      'If you’re looking for a set route, then look no further—a Dedicated Lane is right for you! As a Dedicated truck driver, you’ll haul loads for a local company and be instrumental in fostering that relationship for C.R England. Dedicated Lanes offer stable income, predictable home time, and consistent miles.';
  }

  onTermsAndConditionsMobileClose() {
    this.renderer.addClass(document.body, 'ui-overflow-hidden');
  }

  showDialogMaximized(dialog: Dialog) {
    dialog.maximize();
  }

  private emptyJob() {
    this.job = {
      city: '',
      description: '',
      division: '',
      domicileId: -1,
      driverType: '',
      experience: '',
      hideWage: true,
      hideWageYear: true,
      homeTime: '',
      jobId: '',
      state: '',
      title: '',
      wageAverageAnnualized: '',
      wageAverageWeekly: '',
      wageTopAnnualized: '',
      wageTopWeekly: '',
    } as Job;
  }

  private setData() {
    this.emptyJob();
    if (this.jobId) {
      this.isLoading = true;
      this.jobsService
        .jobById(parseInt(this.jobId, 10), this.city, this.state) // 10 = decimal
        .then((apiJob) => {
          this.job = apiJob;
          /// Remove this when quick-apply api is ready
          this.careerURL = `${this.careerDomain}apply?jobid=${this.job.jobId}`;
          if (this.job.domicileId !== -1) {
            this.careerURL += `&domicileid=${this.job.domicileId}`;
          }

          if (this.job.description === '') {
            this.job.description =
              'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore.';
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
}
